import { ApiResponse } from './api'
import type { ApiClient } from './api/ApiClient'
import { ServiceBase } from './api/ServiceBase'
import { CargoMarkSchema, HouseBillSchema } from './CustomsV2Service'
import { PalletPositionSchema } from './OutboundV2Service'

// 搜索类型
export type SearchType = 'mark' | 'pallet' | 'position'

// 箱货统计
export interface Summary {
  total?: number
  pending?: number
  scanned?: number
  pized?: number
  stored?: number
  waiting?: number
}

// MARK查询结果接口
export interface CargoMarkResult extends CargoMarkSchema {
  houseBill: HouseBillSchema
  pallets: PalletPositionSchema[]
}

// 托盘查询结果接口
export interface PalletResult {
  id: number
  palletCode: string
  warehousePosition?: {
    id: number
    code: string
    name: string
  }
  quantity: number
  cargoMarks: {
    id: number
    quantity: number
    cargoMark: {
      id: number
      cargoNumber: string
      sequenceNumber: number
      packages: number
    }
  }[]
  status: string
  statusDisplay: string
}

// 库位查询结果接口
export interface PositionResult {
  id: number
  code: string
  name: string
  quantity: number
  pallets: {
    id: number
    palletCode: string
    quantity: number
    status: string
    statusDisplay: string
  }[]
}

// 搜索结果类型
export type SearchResult = CargoMarkResult // | PalletResult | PositionResult
// | PositionLocationResult

// 统一搜索结果接口
export interface SearchResponse {
  query: string
  queryType: SearchType
  summary?: Summary
  searchResult?: SearchResult
}

export class SearchService extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/v2/search')
  }

  // 统一搜索 - 一个接口查询所有类型
  async search(searchQuery: string) {
    return this.get<ApiResponse<SearchResponse>>(``, {
      params: {
        query: encodeURIComponent(searchQuery)
      }
    })
  }
}

export default SearchService
